import { z } from "zod";
import { twinLogicQueryAuthoritySchema } from "./twin-logic-execution-authority.js";
import { twinAnswerTestAuthoritySchema } from "./twin-answer-tests.js";
const id = z.string().trim().min(1).max(200);
const sha256 = z.string().regex(/^[0-9a-f]{64}$/u);
/** Original execution authority, never a lookup of the currently active version. */
export const twinRunEvaluationAuthoritySchema = z.object({
    productId: z.string().regex(/^tl_prod_[0-9a-f]{32}$/u),
    productVersionId: z.string().regex(/^tl_pver_[0-9a-f]{32}$/u),
    productSha256: sha256,
    answerTest: twinAnswerTestAuthoritySchema.optional(),
    executions: z.array(z.object({
        certificateId: id, certificateSha256: sha256, resultEvidenceSha256: sha256,
        eventId: id, runId: id, attemptNumber: z.number().int().positive(), toolCallId: id,
        authority: twinLogicQueryAuthoritySchema,
    }).strict()).min(1).max(256),
}).strict().superRefine((value, context) => {
    if (value.productVersionId !== `tl_pver_${value.productSha256.slice(0, 32)}` ||
        value.executions.some(e => e.authority.productVersionSha256 !== value.productSha256) ||
        new Set(value.executions.map(e => e.certificateId)).size !== value.executions.length) {
        context.addIssue({ code: "custom", message: "Evaluation must bind unique executions of one exact view contract version." });
    }
    if (value.answerTest?.facts.some(fact => fact.citations.some(citation => !value.executions.some(execution => execution.certificateId === citation.certificateId && execution.certificateSha256 === citation.certificateSha256)))) {
        context.addIssue({ code: "custom", message: "Evaluated citations must belong to the original view executions." });
    }
});
